import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/shopcart/upload_d2c.png'
import _imports_1 from '@/assets/image/shopcart/un_upload_d2c.png'
import _imports_2 from '@/assets/image/shopcart/upload_b2b.png'
import _imports_3 from '@/assets/image/shopcart/un_upload_b2b.png'


const _withScopeId = n => (_pushScopeId("data-v-f6b8a230"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "upload-file-modal-content" }
const _hoisted_2 = { class: "upload-part" }
const _hoisted_3 = {
  key: 0,
  src: _imports_0,
  alt: "",
  class: "upload-part-img"
}
const _hoisted_4 = {
  key: 1,
  src: _imports_1,
  alt: "",
  class: "upload-part-img"
}
const _hoisted_5 = {
  key: 0,
  src: _imports_2,
  alt: "",
  class: "upload-part-img"
}
const _hoisted_6 = {
  key: 1,
  src: _imports_3,
  alt: "",
  class: "upload-part-img"
}
const _hoisted_7 = { class: "upload-part-text" }
const _hoisted_8 = { class: "download-template" }
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "download-tip" }
const _hoisted_11 = { key: 0 }

import { t, lang } from '@/plugins/i18n'
import { uploadExcelApi, searchUploadProgressApi, orderExcelKnowApi, canUseOnTheWayStockApi } from '@/apis/shopcart'
import { ref, onMounted, watch } from 'vue'
import CommonDialog from '@/components/common/CommonDialog.vue'
import UploadFailTable from './UploadFailTable.vue'
import { ElMessage as message } from 'element-plus'
import { isD2C, isJA, isMultiStore, useSite } from '@/store'
import { getExcelFileData } from '@/util/useXlsx'
import { checkOrderExcel, checkGoodsExcel } from '@/util/useXlsxRule'
import { uploadAliOSS, ORDER_TABLE_TRADE } from '@/util/useUpload'
import { excelOrderTemplateHref } from '@/common/const'
import ConfirmStockInTransitModal from './ConfirmStockInTransitModal.vue'
import { sourceCountryRef } from '../country'
import { COUNTRY } from '@/global'

export default /*#__PURE__*/_defineComponent({
  props: {
  mode: {
    type: Number,
    default: 1
  },
  visible: {
    type: Boolean,
    default: false
  },
  isCanUseOnTheWayStock: {
    type: Boolean,
    default: false
  }
},
  emits: ['update:visible', 'submit', 'error'],
  setup(__props, { emit: emits }) {

const props = __props

/** 是否选择在途库存 */
const useOnTheWayStock = ref(false)
/** 该用户是否可以使用在途库存 */
// const isCanUseOnTheWayStock = ref(false)

const loading = ref(false)

const file = ref()
const errorList = ref([])
const uploadFailTableVisible = ref(false)
const upload = (uploadFile: any) => {
  console.log(uploadFile)
  if (uploadFile.size > 20 * 1024 * 1024) {
    message.warning(t('文件大于20M,请重新上传'))
    return false
  }
  file.value = uploadFile
  return false
}
/** 用于在途库存弹窗点击确认时的状态，这个时候的关闭不需要将按钮loading取消  */
const isConfirmClose = ref(false)
/** 文件上传在途库存弹窗 */
const confirmStockInTransitModal = ref()
/** 文件上传在途库存弹窗确认 */
const confirmStockInTransitSuccess = async (val: boolean) => {
  isConfirmClose.value = true
  loading.value = true
  useOnTheWayStock.value = val
  await uploadNextStep()
  isConfirmClose.value = false
}
/** 文件上传在途库存弹窗取消 */
const cancelStockInTransit = () => {
  // 当点击确认关闭弹窗会自动调用本方法，这个时候按钮应该要处于loading状态
  if (!isConfirmClose.value) {
    loading.value = false
  }
}
const ok = () => {
  if (!file.value) {
    message.warning(t('请上传文件'))
    return
  }
  uploadOrder()
}
const cancel = () => {
  file.value = null
  emits('update:visible', false)
  loading.value = false
}
/** 上传之后下一步 */
const uploadNextStep = () => {
  uploadAliOSS({
    file: file.value,
    path: ORDER_TABLE_TRADE,
    bizType: props.mode === 1 ? 'importTrade' : 'importShopCart'
  }).then((res: any) => {
    console.log(res)

    uploadExcelApi({
      ossUrl: res.key,
      taskType: props.mode === 1 ? 1 : 2,
      goodsCountry: sourceCountryRef.value,
      // 只有直发下单且该用户可以使用在线库存
      useOnTheWayStock: props.mode === 1 && props.isCanUseOnTheWayStock ? useOnTheWayStock.value : undefined
    }).then((res: any) => {
      if (!res.success) {
        loading.value = false
        // message.warning(t('上传失败请重试'))
        return
      }
      // 上传完校验一次
      searchUploadProgressApi({
        taskType: props.mode === 1 ? 1 : 2,
        taskId: res.data
      }).then((res: any) => {
        isConfirmClose.value = false
        loading.value = false
        if (res?.data?.message) {
          message.warning(res.data.message)
          orderExcelKnowApi({
            taskId: res.data.taskId
          })
          return
        }
        if (res.data.validFlag === 2) {
          emits('error', (res.data.messageList || []).map((i: any) => {
            return {
              rowNumber: i.line,
              error: i.message
            }
          }))
        } else {
          // 否则关闭弹窗
          cancel()
          emits('submit')
        }
      }).catch(() => {
        loading.value = false
        isConfirmClose.value = false
      })
    }).catch(() => {
      loading.value = false
      isConfirmClose.value = false
      message.warning(t('上传失败请重试'))
    })
  }).catch(() => {
    loading.value = false
    isConfirmClose.value = false
    message.warning(t('上传失败请重试'))
  })
}
const uploadOrder = () => {
  loading.value = true
  getExcelFileData(file.value).then(async (res) => {
    console.log(res, props.mode, '??')
    const excelList = props.mode === 1 ? await checkOrderExcel(res) : checkGoodsExcel(res)
    const list = excelList.filter((e: any) => e.error)
    if (list.length > 0) {
      emits('error', list)
      loading.value = false
      // errorList.value = list
      // uploadFailTableVisible.value = true
    } else {
      // 文件正常
      console.log('校验通过1')
      //   如果用户可以使用在途库存，则打开在途库存的弹窗
      if (props.isCanUseOnTheWayStock) {
        confirmStockInTransitModal.value.open()
        return
      }
      uploadNextStep()
    }
  }).catch(() => {
    loading.value = false
  })
}

const templateHref = () => {
  // 直发
  const key = props.mode === 1 ? 'd2cOrder' : (isD2C() ? 'd2cStock' : 'b2bStock')
  return excelOrderTemplateHref[useSite()][key] + '?v=' + new Date().getTime()
}

return (_ctx: any,_cache: any) => {
  const _component_el_upload = _resolveComponent("el-upload")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CommonDialog, {
      visible: __props.visible,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => (_isRef(visible) ? (visible).value = $event : null)),
      "show-close": false,
      width: 600,
      className: "upload-file-modal",
      onOk: ok,
      onCancel: cancel,
      title: __props.mode === 1 ? _unref(t)('表格导入创建订单') : _unref(t)('表格导入商品'),
      footer: true,
      loading: loading.value,
      disabled: !file.value
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_upload, {
            drag: "",
            action: "",
            "before-upload": upload,
            accept: ".xls,.xlsx"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                (_unref(isD2C)())
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (file.value)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_3))
                        : (_openBlock(), _createElementBlock("img", _hoisted_4))
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (file.value)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                        : (_openBlock(), _createElementBlock("img", _hoisted_6))
                    ], 64)),
                _createElementVNode("div", _hoisted_7, _toDisplayString(!file.value ? _unref(t)('上传文件') : (file.value?.size / 1024 > 1024 ? (file.value?.size / 1024 /
            1024).toFixed(2) + 'M'
            : (file.value?.size / 1024).toFixed(0) + 'KB')), 1)
              ])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("a", {
              href: templateHref() + '?v=' + new Date().getTime()
            }, _toDisplayString(_unref(t)('模板下载2')), 9, _hoisted_9)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", null, _toDisplayString(_unref(t)('注意事项')), 1),
            _createElementVNode("div", null, _toDisplayString(__props.mode === 1 ? _unref(t)('1.表格数据最多为1000行，超过请分多个表格导入') : _unref(t)('1.表格数据最多为200行，超过请分多个表格导入')), 1),
            _createElementVNode("div", null, _toDisplayString(_unref(t)('2.仅支持.xlsx、.xls文件，且小于20M')), 1),
            _createElementVNode("div", null, _toDisplayString(_unref(t)('3.导入成功后，请前往「待付款」，进行付款后完成下单')), 1),
            (_unref(isMultiStore)())
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, "4." + _toDisplayString(_unref(sourceCountryRef) === _unref(COUNTRY).KR ? _unref(t)('不同国家商品不可通过一个表格下单，当前请上传韩国商品') :
          _unref(t)('不同国家商品不可通过一个表格下单，当前请上传中国商品')), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "title", "loading", "disabled"]),
    _createVNode(UploadFailTable, {
      visible: uploadFailTableVisible.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((uploadFailTableVisible).value = $event)),
      list: errorList.value
    }, null, 8, ["visible", "list"]),
    _createVNode(ConfirmStockInTransitModal, {
      ref: (_value, _refs) => {
        _refs['confirmStockInTransitModal'] = _value
        confirmStockInTransitModal.value = _value
      },
      onSuccess: confirmStockInTransitSuccess,
      onCancel: cancelStockInTransit
    }, null, 512)
  ], 64))
}
}

})